import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

interface IMainViewPresenter {
  isCalendarEnabled: boolean;
}

export function useMainViewPresenter(): IMainViewPresenter {
  const presenter = useLocalObservable<IMainViewPresenter>(() => ({
    get isCalendarEnabled(): boolean {
      return Entities.featuresStore.isCalendarIntegrationEnabled;
    },
  }));

  useEffect(() => {
    Tasks.market.getMarketConfig(true);

    return () => {
      Tasks.market.stopUpdateMarketConfig();
    };
  }, []);

  return presenter;
}
